<template>
  <div class="apply">
    <div class="template-list" v-for="data in datas" :key="data.name">
      <span>{{data.name}}:</span>
      <div v-if="data.state=='input'">
        <el-input :placeholder="data.place" v-model="data.model" clearable></el-input>
      </div>
      <div v-else-if="data.state=='radio'" class="radio">
        <el-radio v-model="data.model" label="女">女</el-radio>
        <el-radio v-model="data.model" label="男">男</el-radio>
      </div>
      <div v-else>
        <el-select v-model="data.model" placeholder="请选择">
          <el-option
            v-for="item in data.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div class="party">
      <span>所在党支部:</span>
      <chooseParty @change-party="changeParty" />
    </div>

    <div class="upload">
      <div v-for="(imgUrl,index) in imgUrls" :key="imgUrl.img">
        <i class="el-icon-close" @click="cancle(index)"></i>
        <img v-if="imgUrl.img" :src="imgUrl.img" alt class="showImg" />
      </div>

      <img src="@/assets/index/joinParty/dp-lc1-ph.png" @click="addImg" />
      <input style="display: none" id="input" type="file" class="inputs" />
      <p>上传纸质版入党申请书</p>
    </div>

    <div class="submit">
      <button @click="submit">确认提交</button>
    </div>
    <div class="motai" v-if="motai">
      <div class="msg">
        <img src="@/assets/index/joinParty/dp-lc1-no2.png" alt />
        <div>
          <h5>提交入党申请书成功</h5>
          <p>党组织收到申请书一月内会对您进行了解基本情况，安排谈话，后续消息将会以手机电话或通过平台发送，请注意查收</p>
          <button @click="goBack()">我知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chooseParty from "@/views/component/chooseParty.vue";
export default {
  data() {
    return {
      datas: [
        { name: "姓名", state: "input", model: "", place: "请输入姓名" },
        { name: "性别", state: "radio", model: "女" },
        {
          name: "出生年月",
          state: "input",
          model: "",
          place: "请以'-'分隔"
        },
        {
          name: "学历",
          state: "select",
          model: "",
          options: [
            {
              value: "初中",
              label: "初中"
            },
            {
              value: "高中",
              label: "高中"
            },
            {
              value: "大专",
              label: "大专"
            },
            {
              value: "本科",
              label: "本科"
            },
            {
              value: "研究生",
              label: "研究生"
            }
          ]
        },
        { name: "民族", state: "input", model: "", place: "请输入民族" },
        { name: "籍贯", state: "input", model: "", place: "请输入籍贯" },
        { name: "身份证", state: "input", model: "", place: "请输入身份证" },
        {
          name: "现居住地",
          state: "input",
          model: "",
          place: "请输入现居住地"
        },
        { name: "工作单位", state: "input", model: "", place: "请输入工作单位" }
      ],
      imgUrls: [],
      motai: false,
      partyTemps: ""
    };
  },
  methods: {
    goBack() {
      this.motai = false;
      this.$router.go(-1);
    },
    addImg(event) {
      let imgLength = document.getElementsByClassName("showImg")[
        document.getElementsByClassName("showImg").length - 1
      ];
      let input = document.querySelector(".inputs");
      input.click(); //点击添加事件
      input.onchange = () => {
        var preview = imgLength; //这里是img,调用遍历 寻找dom的类 展示用
        var file = input.files[0]; //得到上传的图片路径
        var reader = new FileReader(); //把file路径转换
        if (file) {
          reader.readAsDataURL(file);
        } else {
          //   preview.src = "";
        }
        reader.onloadend = () => {
          if (reader.result.length / 1380 > 2000) {
            alert("文件太大,请重新上传");
          } else {
            this.imgUrls.push({ img: reader.result });
          }
        };
      };
    },
    cancle(index) {
      this.imgUrls.splice(index, 1);
    },
    changeParty(e) {
      this.partyTemps = e;
    },
    submit() {
      let goOn = true;
      this.datas.some(item => {
        if (item.model == "") {
          alert("请输入完整");
          goOn = false;
          return true;
        }
      });
      if (!goOn) return;
      if (this.partyTemps[0].value == "" || this.partyTemps[1].value == "") {
        alert("请选择党支部");
        return;
      }
      if (this.imgUrls.length == 0) {
        alert("请上传图片");
        return;
      }
      let tier = 0;

      let string = "";
      this.imgUrls.filter(item => {
        string = string + item.img.replace(/data(\S*?)base64,/, "") + ";";
      });
      let end = () => {
        for (let x = this.partyTemps.length - 1; x >= 0; x--) {
          if (this.partyTemps[x].value != "") {
            return this.partyTemps[x];
          }
        }
      };
      this.axios
        .post("/api/Index/PostuserApplicant", {
          userid: sessionStorage.getItem("id"),
          name: this.datas[0].model,
          sex: this.datas[1].model,
          birthday: this.datas[2].model,
          gradeid: this.datas[3].model,
          nation: this.datas[4].model,
          place: this.datas[5].model,
          pid: this.datas[6].model,
          live: this.datas[7].model,
          Company: this.datas[8].model,
          branchID: end().value,
          branchName: end().name
        })
        .then(e => {
          if (e.data.code == 0) {
            this.axios
              .post("/api/Index/Addrecored", {
                userid: sessionStorage.getItem("id"),
                stateid: 1,
                requesttime: new Date()
              })
              .then(es => {
                if (es.data.code == 0) {
                  this.axios
                    .post("/api/Index/Addrecored", {
                      userid: sessionStorage.getItem("id"),
                      stateid: 1,
                      requestimg: string,
                      requesttime: new Date()
                    })
                    .then(e => {
                      if (e.data.code == 0) {
                        alert("添加成功");
                        this.$router.go(-1);
                      } else {
                        alert("添加失败,请重新添加");
                      }
                    });
                } else {
                  alert("添加失败");
                }
              });
          } else {
            alert("添加失败");
          }
        });
    },
    amend() {
      this.axios
        .get("/api/Index/GetUserSum?userid=" + sessionStorage.getItem("id"))
        .then(e => {
          console.log(e.data);

          switch (e.data.code) {
            case 0:
              this.datas[0].model = e.data.msg[0].name;
              this.datas[1].model = e.data.msg[0].sex;
              this.datas[2].model = e.data.msg[0].birthday;
              this.datas[3].model = e.data.msg[0].gradeid;
              this.datas[4].model = e.data.msg[0].nation;
              this.datas[5].model = e.data.msg[0].place;
              this.datas[6].model = e.data.msg[0].pid;
              this.datas[7].model = e.data.msg[0].live;
              this.datas[8].model = e.data.msg[0].Company;
              break;
            default:
              break;
          }
        });
    }
  },
  components: {
    chooseParty
  },
  mounted() {
    if (this.$route.query.verify) this.amend();
  }
};
</script>
<style lang='scss' scoped>
.apply {
  .party {
    background: #fff;
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .motai {
    .msg {
      div {
        button {
          background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
          font-size: 0.28rem;
          color: #fff;
          border: none;
          padding: 0.1rem 0.4rem;
          border-radius: 0.34rem;
          margin-top: 0.3rem;
        }
        h5 {
          font-weight: bold;
          font-size: 0.3rem;
        }
        p {
          text-align: left;
          padding: 0.2rem;
          font-size: 0.28rem;
          color: #999999;
        }
        width: 4.4rem;
        margin: 0 auto;
        margin-top: -3.7rem;
      }
      img {
        width: 4.4rem;
      }
      text-align: center;
      margin-top: 20vh;
      position: relative;
    }
    position: fixed;
    width: 100%;
    top: 0;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.2);
  }
  .submit {
    button {
      padding: 0.2rem 1rem;
      border: none;
      border-radius: 0.08rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
      font-size: 0.3rem;
      color: #fff;
    }
    text-align: center;
    background: #fff;
    margin-top: 0.2rem;
    padding: 0.8rem 0;
  }
  .upload {
    div {
      i {
        position: absolute;
        bottom: -0.2rem;
        left: 33%;
        font-size: 0.3rem;
      }
      position: relative;
    }

    p {
      position: absolute;
      left: 30%;
      top: 0.2rem;
      color: #999999;
    }
    margin-top: 0.2rem;
    padding: 0.2rem;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    img {
      width: 1.46rem;
      height: 1.46rem;
      margin: 0.5rem 0.2rem 0 0;
    }
    position: relative;
  }
  .template-list {
    .radio {
      margin-right: 0.3rem;
    }
    padding: 0.2rem;
    display: flex;
    align-items: center;
    background: #fff;
    justify-content: space-between;
    border-bottom: 0.01rem solid #f9f9f9;
  }
  padding-top: 1.1rem;
  font-size: 0.3rem;
}
</style>

<style lang="scss">
.apply {
  .template-list {
    &:nth-child(5) {
      margin-top: 0.2rem;
    }
    &:nth-child(8) {
      margin-top: 0.2rem;
    }
    input {
      border: none;
      text-align: right;
      font-size: 0.3rem;
    }
  }
}
</style>